import React from 'react';
import { menuPage } from '@/data/content';
import Button from '@/components/ui/Button';
import { SpinnerIcon } from '@/components/ui/Icons';

interface ApplyButtonProps {
    applyLabel: 'Counter' | 'Available';
    pickedDate: Date | null;
    fetching: boolean;
    itemCount: number | null;
    onApply: () => void;
}

const ApplyButton: React.FC<ApplyButtonProps> = ({ applyLabel, pickedDate, fetching, itemCount, onApply }) => {
    const isDisabled = !pickedDate || fetching || itemCount === 0;

    const label = (() => {
        if (fetching) return null;

        if (applyLabel === 'Counter') {
            if (itemCount === null) return menuPage.filter_apply;
            if (itemCount === 0) return 'Aucun Plat';
            return `${itemCount} plats · Appliquer`;
        }

        // applyLabel === 'Available'
        if (itemCount === null) return menuPage.filter_apply;
        if (itemCount === 0) return 'Indisponible';
        return 'Appliquer';
    })();

    return (
        <Button
            variant="primary"
            onClick={onApply}
            disabled={isDisabled}
            className="flex-1 py-2.5 px-4 rounded-xl text-sm font-bold bg-app-primary text-white shadow-md shadow-app-primary/20 hover:bg-app-primary/90 transition-colors disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {fetching ? (
                <SpinnerIcon />
            ) : (
                label
            )}
        </Button>
    );
};

export default ApplyButton;
